import { useEffect, useState } from 'react';

export const usePWA = () => {
  const [isPWA, setIsPWA] = useState(false);
  const [isIOS, setIsIOS] = useState(false);

  useEffect(() => {
    // ✅ DETECTAR MODO PWA
    const checkPWA = () => {
      // Detectar si está en modo standalone (PWA)
      const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
      // Detectar si está en modo fullscreen (PWA)
      const isFullscreen = window.matchMedia('(display-mode: fullscreen)').matches;
      // Detectar si está en modo minimal-ui (PWA)
      const isMinimalUI = window.matchMedia('(display-mode: minimal-ui)').matches;
      
      setIsPWA(isStandalone || isFullscreen || isMinimalUI);
    };

    // ✅ DETECTAR iOS
    const checkIOS = () => {
      const isIOSDevice = /iPad|iPhone|iPod/.test(navigator.userAgent);
      const isWebKit = /WebKit/.test(navigator.userAgent);
      const isNotChrome = !/Chrome/.test(navigator.userAgent);
      
      setIsIOS(isIOSDevice && isWebKit && isNotChrome);
    };

    // ✅ APLICAR ESTILOS ESPECÍFICOS PARA PWA
    const applyPWAStyles = () => {
      if (isPWA) {
        // Ocultar barra de Safari
        document.body.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden';
        
        // Prevenir zoom
        document.addEventListener('gesturestart', (e) => e.preventDefault());
        document.addEventListener('gesturechange', (e) => e.preventDefault());
        document.addEventListener('gestureend', (e) => e.preventDefault());
        
        // Prevenir scroll en iOS
        if (isIOS) {
          document.body.style.position = 'fixed';
          document.body.style.width = '100%';
          document.body.style.height = '100%';
        }
      }
    };

    checkPWA();
    checkIOS();
    applyPWAStyles();

    // ✅ ESCUCHAR CAMBIOS EN EL MODO DE DISPLAY
    const mediaQuery = window.matchMedia('(display-mode: standalone)');
    mediaQuery.addListener(checkPWA);

    return () => {
      mediaQuery.removeListener(checkPWA);
    };
  }, [isPWA, isIOS]);

  return { isPWA, isIOS };
}; 